export const getLinkIcon = (openIcon, closeIcon, isOpen, shouldShow = true) =>
  shouldShow && openIcon && closeIcon
    ? {
        props: isOpen ? closeIcon : openIcon,
      }
    : undefined;
